(function(){

    /*
    * Ottimizzazione riproduzione video Hero
    * */

    const v = document.getElementById('heroVideo');
    if (!v) return;

    // Muted + inline: richiesti per autoplay su iOS
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prefersReducedData   = window.matchMedia?.('(prefers-reduced-data: reduce)').matches === true;
    const saveData             = (navigator.connection && navigator.connection.saveData) === true;

    // Se utente non vuole movimento o dati: mostra poster e ferma tutto
    if (prefersReducedMotion || prefersReducedData || saveData) {
        v.removeAttribute('autoplay');
        v.pause();
        // Non caricare le sorgenti per risparmiare dati
        return;
    }

    // Carica effettivamente gli URL dalle data-* quando entra in viewport
    const hydrateSources = () => {
        const sources = v.querySelectorAll('source[data-src]');
        sources.forEach(s => {
            if (!s.src) s.src = s.getAttribute('data-src');
            s.removeAttribute('data-src');
        });
        // Forza ricalcolo delle sorgenti e tenta il play
        v.load();
        tryPlay();
    };

    const tryPlay = () => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
            p.catch(() => {
                // Ritenta in caso di blocco temporaneo
                setTimeout(() => v.play().catch(()=>{}), 80);
            });
        }
    };

    // Lazy init: parte appena il blocco è visibile (~10% visibilità)
    const io = new IntersectionObserver((entries) => {
        const visible = entries.some(e => e.isIntersecting);
        if (visible) {
            hydrateSources();
            io.disconnect();
        }
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    io.observe(v);

    // Se per qualche motivo i sorgenti sono già presenti (es. hai usato <link rel="preload">), prova subito
    if (v.querySelector('source:not([data-src])')) {
        tryPlay();
    } else {
        // Se vuoi avvio istantaneo sopra la fold senza IO, scommenta:
        hydrateSources();
    }

    // Riprendi il loop quando torni dalla bfcache
    window.addEventListener('pageshow', (e) => { if (e.persisted) tryPlay(); });

    // Pausa quando la scheda è nascosta (risparmio batteria)
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) v.pause(); else tryPlay();
    }, false);


    /*
    * Inizializzazione Swiper.js per news
    * */
    var swiper = new Swiper(".chSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });

})();
